import React, { forwardRef, useContext } from "react";
import { BsPinAngleFill, BsPinAngle } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import appContext from "../../context/app/appContext";
import { FiGrid } from "react-icons/fi";
import { FaCalendarAlt, FaSearch } from "react-icons/fa"; // <-- new icon

const Sidebar = forwardRef(
  ({ isSidebarOpen, isPinned, toggleSidebar, togglePin }, ref) => {
    const navigate = useNavigate();
    const { categoryAdminSupport, dbUser } = useContext(appContext);

    return (
      <div
        ref={ref}
        className={`fixed left-0 top-0 h-full bg-blue-500 text-white w-64 p-2 shadow-lg transform transition-transform duration-300 ease-in-out
      ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
      `}
      >
        <div className="flex justify-between items-start">
          <div
            onClick={() => {
              navigate("/");
            }}
            className="hover:cursor-pointer text-2xl text-gray-50 hover:text-orange-400 hover:scale-105 transition-all duration-200 "
          >
            <img
              src="/GoWhite.png"
              alt="Go"
              style={{ height: "150px", width: "150px" }}
              className=" ml-4 object-contain"
            />
          </div>
          <div className="flex gap-2">
            <button
              className={`p-2 ${
                isPinned ? "text-yellow-400" : "text-gray-300"
              } hover:text-white transition`}
              onClick={() => {
                if (isSidebarOpen && isPinned) {
                  toggleSidebar();
                }
                togglePin();
              }}
            >
              {isPinned ? (
                <BsPinAngleFill size={25} />
              ) : (
                <BsPinAngle size={25} />
              )}
            </button>
          </div>
        </div>

       

        <div
          onClick={() => navigate("/calendar")}
          className="flex items-center gap-3 px-4 py-2 mt-1 rounded hover:bg-blue-600 cursor-pointer transition text-white text-base font-medium"
        >
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/10">
            <FaCalendarAlt size={18} />
          </span>
          <span className="truncate">Calendar</span>
        </div>

        <div
          onClick={() => navigate("/calendarSearch")}
          className="flex items-center gap-3 px-4 py-2 mt-1 rounded hover:bg-blue-600 cursor-pointer transition text-white text-base font-medium"
        >
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/10">
            <FaSearch size={18} />
          </span>
          <span className="truncate">Search Calendar</span>
        </div>
        {categoryAdminSupport?.some(
          (entry) =>
            entry.employee_id === dbUser?.staffEmpCode && entry.is_active
        ) && (
          <div
            onClick={() => navigate("/tassEntry/0")}
            className="flex items-center gap-3 px-4 py-2 mt-2 rounded hover:bg-blue-600 cursor-pointer transition text-white text-base font-medium"
          >
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/10">
              <FiGrid size={18} />
            </span>
            <span className="truncate">TASS Entry</span>
          </div>
        )}
      </div>
    );
  }
);

export default Sidebar;
